// subscription/config/featureMap.js

const amFeatureMap = {
    "Standard Monthly": {
        includes: "Includes Free, Plus:",
        features: [
            "Software Inventory",
            "Hardware Inventory",
            "Software License Management",
            "Software Category",
            "Reports and Analytics",
            "User Management (Custom Roles)",
        ],
    },
    "Standard Annually": {
        includes: "Includes Free, Plus:",
        features: [
            "Software Inventory",
            "Hardware Inventory",
            "Software License Management",
            "Software Category",
            "Reports and Analytics",
            "User Management (Custom Roles)",
        ],
    },
    "Professional Monthly": {
        includes: "Includes Standard, Plus:",
        features: [
            "Geo Location Tracking",
            "Scheduled Report",
            "Bulk Deployment",
            "Rebranding",
            "Prohibited Software",
            "Advanced Security (IP Restriction, Session Management, TFA etc)",
        ],
    },
    "Professional Annually": {
        includes: "Includes Standard, Plus:",
        features: [
            "Geo Location Tracking",
            "Scheduled Report",
            "Bulk Deployment",
            "Rebranding",
            "Prohibited Software",
            "Advanced Security (IP Restriction, Session Management, TFA etc)",
        ],
    },
};

const emFeatureMap = {
    "Standard Monthly": {
        includes: "Standard Edition:",
        features: [
            "Inventory",
            "Patch Management",
            "Configuration Profiles",
            "Software Deployment",
            "Remote Script",
            "Remote Access & Tools",
            "User Management",
        ],
    },
    "Standard Annually": {
        includes: "Standard Edition:",
        features: [
            "Inventory",
            "Patch Management",
            "Configuration Profiles",
            "Software Deployment",
            "Remote Script",
            "Remote Access & Tools",
            "User Management",
        ],
    },
    "Professional Monthly": {
        includes: "Professional Edition:",
        features: [
            "Software License Management",
            "Software Metering",
            "BitLocker Management",
            "Power Management",
            "Alerts & Monitoring",
            "Advanced Compliance Reports",
            "Rebranding & Advanced Settings",
        ],
    },
    "Professional Annually": {
        includes: "Professional Edition:",
        features: [
            "Software License Management",
            "Software Metering",
            "BitLocker Management",
            "Power Management",
            "Alerts & Monitoring",
            "Advanced Compliance Reports",
            "Rebranding & Advanced Settings",
        ],
    },
};

const raFeatureMap = {
    "Standard Monthly": {
        includes: "Standard Edition:",
        features: [
            "Unattended Remote Access",
            "Instant Remote Support",
            "Remote Reboot",
            "Remote Wake-on-LAN",
            "Session Notes",
            "Annotation & Whiteboard",
            "Session Audit"  
        ],
    },
    "Standard Annually": {
        includes: "Standard Edition:",
        features: [
            "Unattended Remote Access",
            "Instant Remote Support",
            "Remote Reboot",
            "Remote Wake-on-LAN",
            "Session Notes",
            "Annotation & Whiteboard",
            "Session Audit"  
        ],
    },
    "Professional Monthly": {
        includes: "Professional Edition:",
        features: [
            "Multi-Monitor Support",
            "Remote File Transfer",
            "Live Chat",
            "Advanced Remote Diagnostic Tools (Command Prompt, Task Manager, etc.)",
            "Annotation & Whiteboard",
            "User Role & Access Management",
            "Rebranding & Advanced Configuration Settings"
        ],
    },
    "Professional Annually": {
        includes: "Professional Edition:",
        features: [
            "Multi-Monitor Support",
            "Remote File Transfer",
            "Live Chat",
            "Advanced Remote Diagnostic Tools (Command Prompt, Task Manager, etc.)",
            "Annotation & Whiteboard",
            "User Role & Access Management",
            "Rebranding & Advanced Configuration Settings"
        ],
    },
};

export const getFeatureMap = (product) => {
    if (product === "am") 
        return amFeatureMap;
    if (product === "ra")
        return raFeatureMap;
    return emFeatureMap;
};